import React, { useEffect, useState } from 'react'
import { useMutation, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { emailSessionPath } from 'components/routes/api'
import { api } from 'components/api'
import HeaderIcon from 'images/authentication_modals/email.svg'

type RedirectPath = string | null

interface EmailSessionResponse {
  status: string
  redirectPath: RedirectPath
}

async function submitEmail (email: string): Promise<EmailSessionResponse> {
  const res = await api.postWithCsrf({
    url: emailSessionPath(),
    data: { email }
  })

  return res.data as EmailSessionResponse
}

function EmailOnlyForm (): React.ReactElement {
  const [email, setEmail] = useState('')
  const [redirectPath, setRedirectPath] = useState<RedirectPath>(null)
  const [error, setError] = useState<boolean>(false)

  useEffect(() => {
    if (redirectPath == null) { return }

    const timeout = setTimeout(() => {
      window.location.href = redirectPath
    }, 1000)

    return () => clearTimeout(timeout) // clear timeout on unmount
  }, [redirectPath])

  const mutation = useMutation({
    mutationFn: submitEmail,
    onSuccess: (data) => {
      setError(false)
      const redirectPath = data.redirectPath
      console.log('onSuccess redirect', redirectPath)
      setRedirectPath(redirectPath)
      setEmail('')
    },
    onError: (_err) => {
      setRedirectPath(null)
      setError(true)
    }
  })

  const handleSubmit = (e: React.FormEvent): void => {
    e.preventDefault()
    mutation.mutate(email)
  }

  if (redirectPath != null) {
    return <p>Your email has been submitted! ... you will be forwarded</p>
  }

  if (error) {
    return <p>We're sorry there was an error</p>
  }

  return (

    <form onSubmit={handleSubmit}>
      <div className='modal-top'>
        <img src={HeaderIcon} alt='Enter Email' className='header-icon' />
        <div className='header pro-head-5' role='heading'>
          Enter Email
        </div>
      </div>

      <label htmlFor='email'>Email</label>
      <input
        aria-label='email'
        name='email'
        type='email'
        placeholder='name@example.com'
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        disabled={mutation.isLoading}
      />
      <button className='button float-right next' type='submit' disabled={mutation.isLoading}>
        {mutation.isLoading ? 'Submitting...' : 'Submit'}
      </button>

      <div className='clearfix' />
    </form>

  )
}

export function EmailOnlyModal (): React.ReactElement {
  const queryClient = new QueryClient()

  return (
    <QueryClientProvider client={queryClient}>
      <div className='pro-modal-overlay'>
        <div className='pro-modal'>
          <EmailOnlyForm />
        </div>
      </div>
    </QueryClientProvider>
  )
}
